/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_EmptyInputs */

const en_my_payments_empty = /** @type {(inputs: My_Payments_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No payments yet.`)
};

const pl_my_payments_empty = /** @type {(inputs: My_Payments_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak płatności.`)
};

/**
* | output |
* | --- |
* | "No payments yet." |
*
* @param {My_Payments_EmptyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_empty = /** @type {((inputs?: My_Payments_EmptyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_EmptyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_empty(inputs)
	return en_my_payments_empty(inputs)
});